import { defineMessages } from 'react-intl';

const messages = defineMessages({
  accept: {
    id: 'invitation.accept',
    defaultMessage: 'Accept',
  },
  reject: {
    id: 'invitation.reject',
    defaultMessage: 'Reject',
  },
  roleAssistantTrainer: {
    id: 'invitation.role.assistantTrainer',
    defaultMessage: 'Assistant Trainer',
  },
  roleClient: {
    id: 'invitation.role.client',
    defaultMessage: 'Client',
  },
  roleOrganizationOwner: {
    id: 'invitation.role.organizationOwner',
    defaultMessage: 'Organization Owner',
  },
  roleTrainer: {
    id: 'invitation.role.trainer',
    defaultMessage: 'Trainer',
  },
  textPartOne: {
    id: 'invitation.textPartOne',
    defaultMessage:
      'You have an invitation from organization {organizationName}',
  },
  textPartTwo: {
    id: 'invitation.textPartTwo',
    defaultMessage: 'to join as a {role}.',
  },
  textPartTwoNoRole: {
    id: 'invitation.textPartTwoNoRole',
    defaultMessage: 'to join the organization.',
  },
  title: {
    id: 'invitation.title',
    defaultMessage: 'New invitation',
  },
  termsOfUseTitle: {
    id: 'invitation.termsOfUseTitle',
    defaultMessage: 'Accept the membership Terms of Use',
  },
  termsOfUseAcceptLabel: {
    id: 'invitation.termsOfUseAcceptLabel',
    defaultMessage: 'I have read and accept these Terms of Use',
  },
});
export default messages;
